import React from "react";
import SectionVideo from "./Video.styled";
import {Color} from "../Common/Colors";
import Container from "../Common/Container.styled";
import H2 from "../Common/H2.styled";
import StyledVideoGrid from "./VideoGrid.styled";
import StyledVideoCard from "./VideoCard.styled";
import GradPOCDemo from "../../images/0010-IMG_0401.jpg";
import GradAshley2021 from "../../images/Ashley_PhotoMontage.jpg";
import GradJonathan2022 from "../../images/Jonathan_PhotoMontage.png";
import EffertzFamilyReunion2022 from "../../images/EffertzFamilyBackground.png";

const Video = () => {

    return (
        <SectionVideo id="video" backgroundColor={Color.lavender}>
            <H2>Digital Video</H2>
            <Container>
                <StyledVideoGrid>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Senior Night 2023"
                                    src="https://www.youtube.com/embed/K6dtN44TA3M"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Senior Night 2023</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <img src={EffertzFamilyReunion2022}
                                 alt={"Henry &amp; Angeline Effertz Family Dec. 28, 1948"}
                                 className="image-16-9-ratio"/>
                            <div className="webpage-wrapper">
                                <a href="https://reunion-effertz-family.netlify.app" className="webpage-link"
                                   target="_blank" rel="noreferrer">Link to Personal Web Page</a>
                            </div>
                        </div>
                        <div className="video_label">Effertz Family Renunion 2022</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <img src={GradJonathan2022}
                                 alt={"Jonathan Graduation 2022 Montage"}
                                 className="image-16-9-ratio"/>
                            <div className="webpage-wrapper">
                                <a href="https://grad-jonathan-effertz.netlify.app/" className="webpage-link"
                                   target="_blank" rel="noreferrer">Link to Personal Web Page</a>
                            </div>
                        </div>
                        <div className="video_label">Jonathan-Graduation 2022</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Senior Night 2022"
                                    src="https://www.youtube.com/embed/E1BePqgIrZI"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Senior Night 2022</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <img src={GradAshley2021}
                                 alt={"Ashley Graduation 2021 Montage"}
                                 className="image-16-9-ratio"/>
                            <div className="webpage-wrapper">
                                <a href="https://grad-ashley-effertz.netlify.app" className="webpage-link"
                                   target="_blank" rel="noreferrer">Link to Personal Web Page</a>
                            </div>
                        </div>
                        <div className="video_label">Ashley-Graduation 2021</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Senior Night 2021"
                                    src="https://www.youtube.com/embed/aYdzX8ewACg"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Senior Night 2021</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <img src={GradPOCDemo}
                                 alt={"Grad POC Demo"}
                                 className="image-16-9-ratio"/>
                            <div className="webpage-wrapper">
                                <a href="https://grad-poc.netlify.app" className="webpage-link" target="_blank"
                                   rel="noreferrer">Link to Personal Web Page</a>
                            </div>
                        </div>
                        <div className="video_label">Grad POC Demo</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Year End Banquet 2019"
                                    src="https://www.youtube.com/embed/rnBb9AwL3g4"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Year End Banquet 2019</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Graduation 2019 playlist"
                                    src="https://www.youtube.com/embed/videoseries?list=PLNm6oEFRS_kGt0_GLwD2Y3WT44DrvD1gl"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Graduation 2019 playlist</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="50th Anniversary playlist"
                                    src="https://www.youtube.com/embed/videoseries?list=PLNm6oEFRS_kFkGBurA0eU2GnnzVM3sGiF"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">50th Anniversary playlist</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Science Field Trip"
                                    src="https://www.youtube.com/embed/FvAXZ4E9WbY"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Science Field Trip</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Wedding"
                                    src="https://www.youtube.com/embed/hg7XB-0IGnc"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Wedding</div>
                    </StyledVideoCard>
                    <StyledVideoCard>
                        <div className="card-16-9-ratio">
                            <iframe className="image-16-9-ratio"
                                    title="Graduation 2016 playlist"
                                    src="https://www.youtube.com/embed/videoseries?list=PLNm6oEFRS_kG5dw1uFaxzsf_xhU18tkWZ"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen/>
                        </div>
                        <div className="video_label">Graduation 2016 playlist</div>
                    </StyledVideoCard>
                </StyledVideoGrid>
            </Container>
        </SectionVideo>
    );
}

export default Video;